import type { HTTPError } from "../generic/request";
import { URLParser } from "../generic/Util";

abstract class StackStateError implements Error {
	stack: string;

	public name: string;

	public message: string;

	constructor(name: string, message: string) {
		this.message = message;
		this.name = name;
		this.stack = new Error().stack ?? "";
	}
}

/**
 * An error that should not occur. It is a programmer mistake.
 */
export class IllegalStateError extends StackStateError {
	public static NAME = "IllegalStateError";

	constructor(message: string) {
		super(IllegalStateError.NAME, message);
	}
}

export class IllegalArgumentError extends StackStateError {
	public static NAME = "IllegalArgumentError";

	constructor(message: string) {
		super(IllegalArgumentError.NAME, message);
	}
}

export const handleHTTPError = ({ message, statusCode, statusText, url }: HTTPError): string => {
	if (statusCode) {
		return `${statusCode === 400 ? "API responded with error" : statusText} (HTTP status: ${statusCode}). ${message}`;
	}
	if (url) {
		const connectionUrl = new URLParser(url);
		return `Could not connect with '${connectionUrl.protocol}//${connectionUrl.host}'.`;
	}
	return `${statusText}. Error: ${message}`;
};
